import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { ptlUtils, ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * HS Management
 * !== HS 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/info/hscd`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/info/hscd`,
    nodes: [
        { path: "/", label: "L_CLR_MGMT" },
        { path: "/trsf/", label: "Tariff" },
        { path: "/trsf/bt/dcla", label: "Transit" },
    ],
};

export const URLS = {
    osci0110001q: `${BASE.path}/osci0110001q`, // HS Management List !== HS 관리 목록 조회 ==!
    osci0110002q: `${BASE.path}/osci0110002q`, // HS Management List !== HS 상세 조회 ==!
};

export const APIS = {
    // get The List of HS Management !== HS 관리 목록 조회 ==!
    getClreHsMgmtPageList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get HS Detail Select !== HS 상세 조회 ==!
    // url 로 파라미터 넘김
    getClreHsDtlSelc: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
};

// HS Management Search Form Schema !== HS 관리 검색 폼 스키마 ==!
// 조회조건 입력폼 생성
export const SF_HS_MGMT_SRCH: TFormSchema = {
    id: "form_ClreHsMgmtSrch",
    schema: {
        hsCd: {
            type: "text",
            label: "L_HS",
            area: "hsCd",
            controlSize: 4,
            rightButton: { icon: "search" },
            placeholder: "0000.00.00.0000",
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsDesc: { type: "text", label: "L_HS_DESC", area: "hsDesc", controlSize: 4, maxLength: 500 },
        appdYn: {
            type: "select",
            label: "L_APPD_YN",
            controlSize: 1,
            all: true,
        },
    },
};

// HS Management List Grid !== HS 관리 List Grid ==!
// 조회결과 리스트 폼
export const SG_HS_MGMT_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "15%" }] },
        { cells: [{ header: "L_VER", binding: "histSrno", width: "10%" }] },
        { cells: [{ header: "L_HS_DESC", binding: "hsDesc", width: "*" }] },
        { cells: [{ header: "L_QTY", binding: "itmQtyUtCd", width: "15%" }] },
        { cells: [{ header: "L_APPD_YN", binding: "useYn", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "hsCd" }],
        },
        {
            cells: [{ binding: "histSrno" }],
        },
        {
            cells: [{ binding: "hsDesc" }],
        },
        {
            cells: [{ binding: "itmQtyUtCd" }],
        },
        {
            cells: [{ binding: "useYn" }],
        },
    ],
};

// Schema of HS Detail Select Form !== HS 상세 조회 폼 스키마 ==!
export const SF_HS_DTL_SRCH: TFormSchema = {
    id: "form_HsDtlSrch",
    schema: {
        hsCdSrch: { type: "code", label: "L_HS_CD", controlSize: 6, area: "hsCd" },
        hsCd: { label: "L_HS_CD", mask: ptlUtils.setHsCodeMask(), controlSize: 2 },
        hsDesc: { type: "text", label: "L_HS_DESC", controlSize: 10 },
        itmQtyUtCd: { label: "L_QTY_UT_CD", controlSize: 2 },
        useYn: {
            label: "L_APPD_YN",
            controlSize: 1,
            all: true,
        },
        regstId: { label: "L_RGST_ID", controlSize: 2 },
    },
};
